<app-generic-table-header
	[config]="simHeaderOptions"
	(selectAllPressed)="selectAllDevices($event)"
	(exportPressed)="exportReport($event)"
	(refreshEvent)="refreshTable($event)"></app-generic-table-header>

<!-- Sim table -->
<div *ngIf="!loading && items.length > 0">
	<ng-template
		#prefixTemplate
		let-row>
		<app-card-table-actions
			[row]="row"
			(actionEvent)="selectDevice($event)"
			[breakpoint]="ScreenSize.TABLET"
			></app-card-table-actions>
	</ng-template>
	<app-card-table
		#Sims
		[data]="items"
		[currentPage]="currentPage"
		[totalItems]="totalItems"
		[tableHeaders]="simTableHeaders"
		[options]="simTableOptions"
		[enableInfiteScroll]="false"
		[enableTablePagination]="true"
		[prefixTemplate]="prefixTemplate"
		(dataScrolledEvent)="(null)"
		(paginateEvent)="paginateSims($event)"
		[breakpoint]="ScreenSize.TABLET"
		[enableRefresher]="true"
		[allSelected]="allItemsSelected"
		(rowSelectedEvent)="onRowSelected($event)">
	</app-card-table>
</div>
<div *ngIf="loading">
	<mat-spinner
		class="spinner"
		name="crescent"></mat-spinner>
</div>

<div
	*ngIf="!loading && items.length == 0"
	class="centered">
	No devices to display
</div>
